<template>
    <!-- 主体区域 -->
    <section id="app">
        <MyHeader @add="add"></MyHeader>
        <MyMain :list="list" @del="del"></MyMain>
        <MyFooter :list="list" @clean="clean"></MyFooter>
    </section>
</template>

<script>
import MyHeader from "./components/MyHeader.vue";
import MyMain from "./components/MyMain.vue";
import MyFooter from "./components/MyFooter.vue";

export default {
    components: {MyFooter, MyMain, MyHeader},
    data() {
        return {
            list: JSON.parse(localStorage.getItem('list'))
                || ['a', 'b', 'c']
        }
    },
    methods: {
        add(v) {
            this.list.push(v)
        },
        del(i) {
            this.list.splice(i, 1)
        },
        clean() {
            this.list = []
        }
    },
    watch: {
        list: {
            deep: true,
            handler(newValue) {
                localStorage.setItem('list', JSON.stringify(newValue))
            }
        }
    }
}
</script>

<style>

</style>
